import { notification } from 'antd';
import {
  ADD_TO_SOCKET_LIST,
  EXECUTE_SOCKET_LIST,
} from '../../state/actionTypes';

const notificationKey = 'socketListNotification';

// Execute all socket actions for a user in order
const executeSocketListForUser = async (userId, socketUserMap) => {
  if (!socketUserMap[userId]) return;

  try {
    // eslint-disable-next-line no-restricted-syntax
    for (const item of socketUserMap[userId]) {
      // eslint-disable-next-line no-await-in-loop
      await item();
    }
  } catch (_e) {
    // fail silently
  }
};

export const executeSocketList = (userId) => async (dispatch, getState) => {
  const { socketUserMap } = getState().socket;
  const userIds = Object.keys(socketUserMap);

  // If a userId is provided, execute only for that user
  // Otherwise, execute for all users
  if (userId) {
    await executeSocketListForUser(userId, socketUserMap);
    if (userIds.length === 1) {
      notification.close(notificationKey);
    }
  } else {
    await Promise.all(userIds.map((uId) => executeSocketListForUser(uId, socketUserMap)));
    notification.close(notificationKey);
  }

  if (socketUserMap.approvals) {
    await executeSocketListForUser('approvals', socketUserMap);
  }

  const result = userId ? socketUserMap[userId]?.length : userIds.length;

  dispatch({
    type: EXECUTE_SOCKET_LIST,
    payload: userId ? [userId] : userIds,
  });

  return result;
};

export const addToSocketList = (payload, userId, isApprovals) => async (dispatch) => {
  dispatch({
    type: ADD_TO_SOCKET_LIST,
    payload: {
      data: payload,
      userId,
      isApprovals,
    },
  });

  notification.close(notificationKey);
  notification.info({
    key: notificationKey,
    message: 'New data available',
    description: 'Click to refresh',
    onClick: () => {
      dispatch(executeSocketList());
      notification.close(notificationKey);
    },
    duration: null,
    style: {
      cursor: 'pointer',
    },
  });
};
